module.exports = __webpack_public_path__ + "static/media/ic_adult.96a669a7.svg";